export const SIDEBAR_WIDTH_EXPANDED = '190px'
export const SIDEBAR_WIDTH_COLLAPSED = '42px'